export const DEMO_DATA = {
  UPLOAD_DEMO_FILE: 'UPLOAD_DEMO_FILE',
  DOWNLOAD_ERROR_FILE: 'DOWNLOAD_ERROR_FILE',
  CHECK_DAG_STATUS: 'CHECK_DAG_STATUS',
};
